import type { ReferentialEnum } from "./referential"
import type { SpecificUniverseName } from "./universe.enum"

export type SpecificFamilyName = keyof typeof specificFamilyEnum
export const specificFamilyEnum = {
  // SC_HIGH_COST_MEDICATIONS
  PRICE_LEVEL_1_91: {
    label: "≥ 1,91 €",
    specificCategory: "SC_HIGH_COST_MEDICATIONS",
  },
  PRICE_LEVEL_22_90: {
    label: "≥ 22,90 €",
    specificCategory: "SC_HIGH_COST_MEDICATIONS",
  },
  PRICE_LEVEL_150_00: {
    label: "≥ 150,00 €",
    specificCategory: "SC_HIGH_COST_MEDICATIONS",
  },
  PRICE_LEVEL_1930_00: {
    label: "≥ 1930,00 €",
    specificCategory: "SC_HIGH_COST_MEDICATIONS",
  },

  // SC_BIOSIMILARS
  ADALIMUMAB: { label: "Adalimumab", specificCategory: "SC_BIOSIMILARS" },
  ENOXAPARINE: { label: "Enoxaparine", specificCategory: "SC_BIOSIMILARS" },
  ETANERCEPT: { label: "Etanercept", specificCategory: "SC_BIOSIMILARS" },
  AFLIBERCEPT: { label: "Aflibercept", specificCategory: "SC_BIOSIMILARS" },
  FILGRASTIM: { label: "Filgrastim", specificCategory: "SC_BIOSIMILARS" },
  PEGFILGRASTIM: { label: "Pegfilgrastim", specificCategory: "SC_BIOSIMILARS" },
  TERIPARATIDE: { label: "Tériparatide", specificCategory: "SC_BIOSIMILARS" },
  RANIBIZUMAB: { label: "Ranibizumab", specificCategory: "SC_BIOSIMILARS" },
  EPOETINE: { label: "Epoétine", specificCategory: "SC_BIOSIMILARS" },
  USTEKINUMAB: { label: "Ustekinumab", specificCategory: "SC_BIOSIMILARS" },
  SC_BIOSIMILARS_OTHERS: {
    label: "Biosimilaires - autres",
    specificCategory: "SC_BIOSIMILARS",
  },

  // SC_VACCINES
  SEASONAL: { label: "Grippe", specificCategory: "SC_VACCINES" },
  POLYVALENT: {
    label: "Calendrier vaccinal - autres",
    specificCategory: "SC_VACCINES",
  },
  TRAVEL: { label: "Voyage", specificCategory: "SC_VACCINES" },

  // SC_GENERICS
  GENERICS_COVERED_REIMBURSABLE: {
    label: "Génériques répertoire remboursé",
    specificCategory: "SC_GENERICS",
  },
  GENERICS_COVERED_NON_REIMBURSABLE: {
    label: "Génériques répertoire non remboursé",
    specificCategory: "SC_GENERICS",
  },
  GENERICS_NON_COVERED_REIMBURSABLE: {
    label: "Génériques hors répertoire remboursé",
    specificCategory: "SC_GENERICS",
  },
  GENERICS_NON_COVERED_NON_REIMBURSABLE: {
    label: "Génériques hors répertoire non remboursé",
    specificCategory: "SC_GENERICS",
  },
  GENERICS_COUNSEL: {
    label: "Génériques Gammes Conseil",
    specificCategory: "SC_GENERICS",
  },

  // SC_HYBRIDS
  HYBRIDS: { label: "Hybrides substituables", specificCategory: "SC_HYBRIDS" },

  // SC_PHARMACY_FEES
  PREVENTION: { label: "Prévention", specificCategory: "SC_PHARMACY_FEES" },
  SCREENING: { label: "Dépistage", specificCategory: "SC_PHARMACY_FEES" },
  CONSULTATIONS: { label: "Entretiens", specificCategory: "SC_PHARMACY_FEES" },
  DISPENSING: { label: "Dispensation", specificCategory: "SC_PHARMACY_FEES" },
} as const satisfies ReferentialEnum<{ specificCategory: SpecificUniverseName }>
